import { render, staticRenderFns } from "./MonitoringProgress.vue?vue&type=template&id=2ed915b0&scoped=true"
import script from "./MonitoringProgress.vue?vue&type=script&lang=js"
export * from "./MonitoringProgress.vue?vue&type=script&lang=js"
import style0 from "./MonitoringProgress.vue?vue&type=style&index=0&id=2ed915b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed915b0",
  null
  
)

export default component.exports